import { FormsyRadioGroup, Radio } from '@thanx/uikit/radio'
import { Switch } from '@thanx/uikit/switch'
import { Text } from '@thanx/uikit/text'
import Section from 'components/Section'
import { buildTranslate } from 'locales'
import React from 'react'
import { FormLabel } from 'react-bootstrap-five'
import DateRangeSection from './DateRangeSection'

type Props = {
  blockId: string
  availabilityType: string
  showStartDate: boolean
  showEndDate: boolean
  startAt?: string
  endAt?: string
  updateContentBlock: (blockId: string, data: any) => void
}

const t = buildTranslate(
  'cms.content.app_home_page.content.edit_block.configuration'
)

const AvailabilitySection = ({
  blockId,
  availabilityType,
  showStartDate,
  showEndDate,
  startAt,
  endAt,
  updateContentBlock,
}: Props) => {
  return (
    <Section className="flex-1 mb-l mr-xs p-l">
      <Text.Header4 className="mb-xs">
        {t('content_display.title')}
      </Text.Header4>
      <Text.BodyText4 color="grey70" className="mb-l">
        {t('content_display.description')}
      </Text.BodyText4>

      <div className="mt-m">
        <FormLabel className="body-text-4 bold mb-s">
          {t('content_display.label')}
        </FormLabel>
        <FormsyRadioGroup
          name={`${blockId}.availability_type`}
          value={availabilityType}
          align="vertical"
          className="mb-l"
        >
          <Radio value="always_available" className="mb-xs">
            <Text.BodyText3>
              {t('content_display.always_available.title')}
            </Text.BodyText3>
          </Radio>
          <Radio value="set_date_range">
            <Text.BodyText3>
              {t('content_display.set_date_range.title')}
            </Text.BodyText3>
          </Radio>
        </FormsyRadioGroup>
      </div>

      <Switch condition={availabilityType === 'set_date_range'}>
        <DateRangeSection
          blockId={blockId}
          showStartDate={showStartDate}
          showEndDate={showEndDate}
          startAt={startAt}
          endAt={endAt}
          updateContentBlock={updateContentBlock}
        />
      </Switch>
    </Section>
  )
}

export default AvailabilitySection
